import kiccEasyCardQueries from '@apis/queries/kiccEasyCardQueries';
import useDeviceId from '@hooks/native/useDeviceId';
import { useQuery } from '@tanstack/react-query';

function useIsBioDevice() {
    const deviceId = useDeviceId();
    const { data } = useQuery({
        ...kiccEasyCardQueries.bioDevice(deviceId!),
        enabled: !!deviceId,
    });

    return !!data?.isBioDevice;
}

export default useIsBioDevice;
